import type { HelpTopicContentLocale } from "../../models/help-topics.models";
import { resolveHelpTopicDirectory } from "../help-topics.helpers";

export const getHelpTopicsManifestPath = (companyId: number): string =>
  `/api/v1/core/c/${companyId}/helpTopics/manifest`;
export const getHelpTopicContentPath = (companyId: number): string =>
  `/api/v1/core/c/${companyId}/helpTopics/topic`;
/** Base the markdown's relative image links (`./assets/x.webp`) resolve against; the backend serves it behind the session. */
export const getHelpTopicAssetsBasePath = ({
  companyId,
  locale,
  topicPath,
}: {
  companyId: number;
  locale: HelpTopicContentLocale;
  topicPath: string;
}): string =>
  `/api/v1/core/c/${companyId}/helpTopics/assets/${locale}/${resolveHelpTopicDirectory(topicPath)}`;
